import { FC, useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import { Box, Typography, TextField, CardContent, Grid, Drawer, Stack, Avatar, CircularProgress, Tooltip, SelectChangeEvent, InputAdornment, Autocomplete, Badge } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import CustomTextField from "../FormFields/CustomTextField";
import DialogClientForm from '../Dialog/CreateClientForm';
import DialogDocumentSettingForm from '../DialogDocumentSettingForm/DialogDocumentSettingForm';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { fetchInvoiceSeqNumber, addInvoiceCreditNote, fetchInvoiceCreditNoteById, dispatchInvoiceCreditNote, updateInvoiceCreditNote } from '../../store/debitNoteStore/debitNoteThunk';
import { fetchInvoicesByInvNumber } from '../../store/invoiceStore/invoiceThunk';

import { fetchAccountById, fetchCounterPartyAccountById } from "../../store/accountThunk";
import { fetchDocumentSettings } from '../../store/documentSettingStore/documentSettingThunk';
import { fetchAccountsByName } from "../../store/accountThunk";
import { EstimateFormInputs } from "../../utils/estimate.types";
import DocAttachInfo from '../DocumentAttachment/DocAttachInfo';
import PayTo from './PayTo';
import DebitNoteButtons from './DebitNoteFooterButtons';
import TemplateSelect from './TemplateSelect'
import { StyledBoxLoader } from './Invoice.style';
import { Utils } from "../../utils/common-utils";
import moment from 'moment';

import CustomSelect, { IOptions } from "../FormFields/CustomSelect";
import { fetchStates } from '../../store/stateStore/stateThunk';
import TableInlineEdit from '../Table/TableInlineEdit';
import { AInvoice, AInvoices, InvoiceFormInputs } from '../../utils/invoice.types';
import { dispatchSale } from '../../store/estimateStore/estimateThunk';
import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import { Padding } from '@mui/icons-material';

// Schema to validate account form.
const schema = yup.object().shape({
  invoiceNumber: yup.string().required("Credit Note Number is required"),
  refInvoiceNumber: yup.string().required("Enter Invoice Number Or Search Ref Invoice"),
  // refInvoiceId: yup.string().required("Please select Invoice from search"),
  client: yup.string().required("Please select Client"),
  account: yup.string().required("Account is required."),
  lineItem: yup.string().required("Minimum 1 Line Item required.")
});

interface DebitNoteProps {
  type: string;
}

// Debit Note component. 
const DebitNote: FC<DebitNoteProps> = ({ type }) => {
  const { pathname } = useLocation();
  const { invoiceId: invoiceId } = useParams();
  const isEditing = invoiceId ? true : false;

  // use form
  const methods = useForm<InvoiceFormInputs>({
    resolver: yupResolver(schema),
  });

  // States
  const [open, setOpen] = useState<Array<boolean>>([false, false, false, false]);
  const [debitNoteDate, setDebitNoteDate] = useState<Date>(new Date());
  const [valueDate, setValueDate] = useState<Date>(new Date());
  const [createDate, setCreateDate] = useState<Date>(new Date());
  const [estimateExpiryDate, setEstimateExpiryDate] = useState<Date>(new Date(Date.now() + 15 * 24 * 60 * 60 * 1000));
  const [poDate, setPoDate] = useState<Date>();
  const [invoiceSeqData, setInvoiceSeqData] = useState<any>();
  const invoiceDetails = useAppSelector(state => state.debitNotes.invoiceDetails);
  const { documentSettings } = useAppSelector(state => state.documentSettings);
  const { selectedAccount } = useAppSelector(state => state.auth);
  const { countries } = useAppSelector(state => state.country);
  const { countryStates } = useAppSelector(state => state.countryState);
  const { docs } = useAppSelector(state => state.docAttach);
  const [inLineItems, setInLineItems] = useState<any[]>([]);
  const [payToObj, setPayToObj] = useState<any>();
  const [editInLineItems, setEditInLineItems] = useState<any[]>([]);
  const [docData, setDocData] = useState<any[]>([]);
  const [selectedClient, setSelectedClient] = useState<any>();
  const [selectedBuyer, setSelectedBuyer] = useState<any>();
  const [selectedAgent, setSelectedAgent] = useState<any>();
  const [isClientLoading, setIsClientLoading] = useState(false);
  const [isBuyerLoading, setIsBuyerLoading] = useState(false);
  const [isAgentLoading, setIsAgentLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isformLoaded, setIsFormLoaded] = useState(false);
  const [fetchData, setFetchData] = useState('');
  const [fetchDocs, setFetchDocs] = useState('');
  const [docDeleteId, setDocDeleteId] = useState("");
  const [invoiceStatus, setInvoiceStatus] = useState("DRAFT");
  const [payToAccount, setPayToAccount] = useState<any>();
  const formRef = useRef<any>();
  const [isDispatched, setIsDispatched] = useState(false);
  const [queryParams, setQueryParams] = useState('');
  const [documentSettingId, setDocumentSettingId] = useState('');
  const [newInvoiceId, setNewInvoiceId] = useState('');

  const [stateOptions, setStateOptions] = useState<IOptions[]>([]);
  const [selectedState, setSelectedState] = useState("");
  const [placeOfSupply, setPlaceOfSupply] = useState("");
  const [selectedIsEditInvoiceDocNumber, setSelectedIsEditInvoiceDocNumber] = useState("");
  
  // search invoice vairables
  const elmRef = useRef<any>(null);
  const [invoiceOptions, setInvoiceOptions] =  useState<any[]>([]);
  const [selectedInvoiceP, setSelectedInvoiceP] = useState<any>('');
  // const [newOption, setNewOption] = useState("");

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const MODULE_TYPE = "sale-debit-note";

  const openCloseDrawer = (label: string) => {
    let openArray = [...open]
    if (label === 'document') {
      openArray[0] = !openArray[0];
    } else if (label === 'client') {
      openArray[1] = !openArray[1];
      setIsClientLoading(true);
    } else if (label === 'agent') {
      openArray[2] = !openArray[2];
      setIsAgentLoading(true);
    } else if (label === 'invoice') {
      alert("clicked");
      setIsAgentLoading(true);
    } else {
      openArray[3] = !openArray[3];
      setIsClientLoading(true);
    }
    setOpen(openArray);
  }

  const closeDialog = (isSaved: boolean) => {
    let openArray = [...open]
    openArray.forEach((x, i) => openArray[i] = false);
    setOpen(openArray);

    if (isSaved) {
      setFetchData(Math.random().toString());
    }
  }
  

  const closeDocAttach = (isSaved: boolean) => {
    if (isSaved) {
      setFetchDocs(Math.random().toString());
    }
  }

  const cancelDialog = () => {
    setIsClientLoading(false); setSelectedAgent(false); setIsAgentLoading(false); setIsLoading(false);
  }

  const handleDateChange = (newValue: Date | null, name: string | undefined) => {
    if (newValue) {
      if (name === 'valueDate') {
        setValueDate(newValue);
      } 
      else if (name === 'estimateExpiryDate') {
        setEstimateExpiryDate(newValue);
      } 
      else {
        setCreateDate(newValue);
      }  
    }
  };

  const rowOnChangeHandler = (data: any) => {
    setInLineItems(data);
  };

  const payToOnChangeHandler = (data: any) => {
    setPayToObj(data);
  };

  const selectedClientHandler = (data: any) => {
    setSelectedClient(data);
  };

  const selectedAgentHandler = (data: any) => {
    setSelectedAgent(data);
  };

  // Method to handle save and send click events
  const selectedDispatchHandler = async (data: any) => {
    console.log("selectedDispatchHandler called ===== ")
    let params = '';
    let currentValues = methods.getValues();
    console.log(currentValues);
    Object.entries(data).forEach(([key, value]) => {
      if (value)
        params += key + '=' + value + '&';
    });
    console.log(params);
    setQueryParams(params.slice(0, -1));
    methods.setValue('pdfTemplate', currentValues.pdfTemplate);
    console.log(formRef)
    if (formRef) {
      console.log("in form ref");
      setIsDispatched(true);
      console.log(formRef?.current)
      console.log(formRef?.current.submit)
      formRef?.current.submit.click();
      console.log("formRef?.current.submit.click() called");
    }
    // }
  };

  // Method to handle invoice form submit.
  const onSubmitForm = async (data: InvoiceFormInputs) => {
    console.log("onsubmit called =========>");
    if (data) {
      console.log(data);
      delete data.lineItem;
      delete data.agent;
      delete data.amountFormat;

      data.lineItems = Object.values(inLineItems);

      data.date = valueDate.toString();
      data.invoiceType = "Debit Note"

      if (type === MODULE_TYPE) {
        data.supplier = selectedAccount._id;
        data.buyer = selectedClient._id;
        data.invoiceAccountRelation = 'AR';
      } else {
        data.supplier = selectedClient._id;
        data.buyer = selectedAccount._id;
        data.invoiceAccountRelation = 'AP';
      }
      data.account = selectedAccount._id;
      let address = (type === MODULE_TYPE) ? selectedClient.addresses : selectedBuyer.addresses;
      let shippingAddress = address.find((item: any) => item.type === 'Shipping');
      let billingAddress = address.find((item: any) => item.type === 'Billing');
      data.billingAddress = (billingAddress) ? billingAddress._id : (type === MODULE_TYPE) ? selectedClient._id : selectedBuyer._id;
      data.shippingAddress = (shippingAddress) ? shippingAddress._id : (type === MODULE_TYPE) ? selectedClient._id : selectedBuyer._id;
      data.client = selectedClient._id;
      if (selectedAgent) data.agent = selectedAgent._id;
    }

    try {
      if (!isEditing) {
        await dispatch(addInvoiceCreditNote(data)).unwrap().then(async (data) => {
          if (data) {
            let _invoiceId = data._id
            if (_invoiceId) setNewInvoiceId(_invoiceId)
          }
        });
      } else {
        if (invoiceId) {
          await dispatch(updateInvoiceCreditNote({ id: invoiceId, invoicePayload: data })).unwrap()
          setNewInvoiceId(invoiceId)
        }
      }
    } catch (error: any) {
      // Empty catch block. 
    }
  };

  //Method to handle Cancel button click.
  const onCancel = () => {
    methods.reset();
    const cancelLink = `/sales`;
    navigate(cancelLink);
  };

  const getEstimateDetails = async () => {
    await dispatch(fetchInvoiceSeqNumber(MODULE_TYPE)).then(async (data: any) => {
      console.log(data);
      if (data.payload) {
        setIsFormLoaded(true);
        setIsLoading(true);
        setInvoiceSeqData(data.payload);
      } else
        methods.trigger("refInvoiceNumber");
    }).catch(e => {
      console.log(e);
    });
  };

  const docDelete = (id: any) => {
    setDocDeleteId(id)
  }

  useEffect(() => {
    dispatch(fetchStates()).unwrap().then(async (data) => {
      console.log(data);
      if (data) {
        if (data.length > 0) {
          await data.forEach(async (item: string | any) => {
            setStateOptions((stateOptions: any) => ([...stateOptions, { label: item.name, value: item._id }]));
          });
        }
      }
    });
  }, []);



  // fetch current invoice details on edit
  useEffect(() => {
    console.log("invoiceId found == " + invoiceId);
    if (invoiceId) {
      console.log("found 111 invoiceId found == " + invoiceId);
      dispatch(fetchInvoiceCreditNoteById({id: invoiceId, invoiceType:MODULE_TYPE}));
    }
  }, [invoiceId, dispatch]);


  useEffect(() => {
    if (docDeleteId) {
      let docs = docData.filter(doc => doc._id !== docDeleteId);
      setDocData([...docs]);
      setDocDeleteId('');
    }
  }, [docDeleteId])

  useEffect(() => {
    const navigateDispatch = async () => {
      if (newInvoiceId) {
        console.log("newInvoiceId true")
        if (isDispatched) {
          console.log("isDispatched true")
          let currentData = methods.getValues();
          await dispatch(dispatchSale(
            { saleId: newInvoiceId, saleType: "Debit Note", params: queryParams, dispatchPayload: { templateId: currentData.pdfTemplate } }))
            .then(async (data: any) => { 
              if (data.payload) onCancel(); 
            });
        } else {
          if (type == 'sale-credit-note') {
            navigate(`/sales/credit-note/edit/${newInvoiceId}`);
          }
          else if (type == 'sale-debit-note') {
            navigate(`/sales/debit-note/edit/${newInvoiceId}`);
          }
          else {
            navigate(`/sales/delivery-note/edit/${newInvoiceId}`);
          }
        }
      }
    }
    navigateDispatch();
  }, [isDispatched, newInvoiceId, dispatch, methods])


  useEffect(() => {
    console.log("calling useEffect for setting address and client Name")
    console.log(selectedClient);

    if (selectedClient) {

      if (type === MODULE_TYPE) { setAddesses(selectedClient) }
      methods.setValue("client", selectedClient.name);
      setIsClientLoading(false);
    }

    if (selectedAgent) {
      methods.setValue("agent", selectedAgent.name);
      setIsAgentLoading(false);
    }
  }, [selectedClient, selectedAgent, methods, countries]);

  // Set edit estimate data in case of edit.
  useEffect(() => {
    const setInitialData = async () => {

      console.log("called setInitialData from main ");
      console.log(invoiceDetails);
      console.log(isEditing);
      console.log("estimatedeails  setInitialData data printed ");
      try {
        if (invoiceDetails || selectedInvoiceP) {
          console.log("called setInitialData from isEditing ");
          console.log(invoiceDetails);
          console.log(isEditing);
          setIsFormLoaded(true);
          setIsClientLoading(true);
          setIsLoading(true);

          console.log("in Edit ===== ", selectedInvoiceP);
          console.log("in Edit creditNoteDetails ===== ", invoiceDetails);
          console.log("in Edit creditNoteDetails.length ===== ", invoiceDetails.length);

          if(selectedInvoiceP && selectedInvoiceP != '') {
            console.log("==== Cond1: Matched selectedInvoiceP && selectedInvoiceP not empty ===== ", selectedInvoiceP)
            methods.setValue('refInvoiceNumber', selectedInvoiceP.invoiceNumber || '');
            methods.setValue('refInvoiceId', selectedInvoiceP._id);
            methods.setValue("poNumber", selectedInvoiceP.poNumber);
            methods.setValue("poDate", selectedInvoiceP.poDate);
            methods.setValue('placeOfSupply', selectedInvoiceP.placeOfSupply);
            setPlaceOfSupply(selectedInvoiceP.placeOfSupply);
            // console.log('selectedInvoiceP?.client?._id: ', selectedInvoiceP?.client?._id);

            let selectedClient = await dispatch(fetchCounterPartyAccountById(selectedInvoiceP?.client?._id));
            setSelectedClient(selectedClient.payload);
            setInLineItems(selectedInvoiceP.lineItems);
            setEditInLineItems(selectedInvoiceP.lineItems);
          }

          if(invoiceDetails && Object.keys(invoiceDetails).length > 0) {
            console.log("==== Cond2: Matched only for few required fields creditNoteDetails =====" , invoiceDetails)
            methods.setValue('invoiceNumber', invoiceDetails.invoiceNumber);
            methods.setValue('date', invoiceDetails.date);
            methods.setValue("account", selectedAccount.name);
            methods.setValue("terms", invoiceDetails.terms);
            methods.setValue("footer1", invoiceDetails.footer1);
            methods.setValue('pdfTemplate', invoiceDetails.pdfTemplate);
            setInvoiceStatus(invoiceDetails.status)
          }

          if(invoiceDetails && selectedInvoiceP == undefined || selectedInvoiceP == '' ) {
            console.log("==== Cond3: Matched only creditNoteDetails && selectedInvoiceP is empty =====", invoiceDetails)
            methods.setValue('refInvoiceNumber', invoiceDetails.refInvoiceNumber || '');
            methods.setValue('refInvoiceId', invoiceDetails.refInvoiceId);
            methods.setValue("poNumber", invoiceDetails.poNumber);
            methods.setValue("poDate", invoiceDetails.poDate);
            methods.setValue('placeOfSupply', invoiceDetails.placeOfSupply);
            setPlaceOfSupply(invoiceDetails.placeOfSupply);
            // console.log('creditNoteDetails?.client?._id: ', creditNoteDetails?.client?._id);

            let selectedClient = await dispatch(fetchCounterPartyAccountById(invoiceDetails?.buyer?._id));
            setSelectedClient(selectedClient.payload);
            setInLineItems(invoiceDetails.lineItems)
            setEditInLineItems(invoiceDetails.lineItems)
          }

          // set the required fields from invoice ( buyer, placeOfSupply, billTo, ShipTo, LineItems)

          // if (isEditing && selectedIsEditInvoiceDocNumber == '') { 
          //   console.log("in edit from credit note edit", selectedInvoiceData.creditNumber);
          //   setSelectedIsEditInvoiceDocNumber(selectedInvoiceData.creditNumber);
          // };
          // methods.setValue('invoiceDocNumber', selectedInvoiceData.creditNumber);
          // // methods.setValue('invoiceNumber', selectedInvoiceData.invoiceNumber);
          // // methods.setValue('invoiceId', selectedInvoiceData._id);
          // methods.setValue("account", selectedAccount.name);
          // methods.setValue("terms", selectedInvoiceData.terms);
          // methods.setValue("footer1", selectedInvoiceData.footer1);
          // // methods.setValue("poNumber", selectedInvoiceData.poNumber);
          // // methods.setValue("poDate", selectedInvoiceData.poDate);
          // methods.setValue("paymentTerms", selectedInvoiceData.paymentTerms);
          // // methods.setValue('pdfTemplate', selectedInvoiceData.pdfTemplate);
          // methods.setValue('creditNoteDate', selectedInvoiceData.date);
          // methods.setValue('placeOfSupply', selectedInvoiceData.placeOfSupply);

          // console.log('placeOfSupply obj: ', selectedInvoiceData.placeOfSupply);
          // setPlaceOfSupply(selectedInvoiceData.placeOfSupply);

          // console.log('selectedInvoiceData?.client?._id: ', selectedInvoiceData?.client?._id);

          // let selectedClient = await dispatch(fetchCounterPartyAccountById(selectedInvoiceData?.client?._id));
          // setSelectedClient(selectedClient.payload);

          // setInLineItems(selectedInvoiceData.lineItems)
          // setEditInLineItems(selectedInvoiceData.lineItems)

          // setCreditNoteDate(selectedInvoiceData.date)

          // setInvoiceStatus(selectedInvoiceData.status)
          // setIsLoading(false);
          // if (estimateDetails.status !== 'DRAFT') onCancel();
          setIsFormLoaded(false);
          setIsClientLoading(false);
          setIsLoading(false);
          console.log("End of initial data form setup ")
        }
      } catch (error: any) {
        // console.log("setInitialData catch block called");
      }
    };

    if (Object.keys(invoiceDetails).length > 0) setInitialData();
    if (selectedInvoiceP) {
      if (Object.keys(selectedInvoiceP).length > 0) setInitialData();
    }
  }, [methods, selectedInvoiceP, invoiceDetails, dispatch, isEditing, selectedAccount, type]);

  /* Search Invoice and set to all fields */


  const onChangeHandler1 = (event: any, value: any) => {
    // setNewOption('');
    // setIsLoading(true);
    
    setSelectedInvoiceP(value);
    console.log("======= Called onChangeHandler ====", selectedInvoiceP);
    // setIsClientEdit(false);
    // setIsLoading(false);
  }

  const onInputChangeHandler1 = async (event: React.SyntheticEvent, value: string) => {
    setSelectedInvoiceP('');
    // setNewOption('');
    await dispatch(fetchInvoicesByInvNumber(value)).unwrap().then((data) => {
      if (data) {
        console.log(data)
        const d = data.invoices.filter(function (item) {
          return item._id !== selectedAccount._id;
        });

        console.log("=========== filter data ==== ", d);

        setInvoiceOptions(d);
      }
    });
  };

  const handleRenderOption1 = (e: any, b: any, c: any) => {
    console.log(b.buyer.name)
    // console.log('b.counterPartyOfAccount: ', b.counterPartyOfAccount, b.name);
    return <div {...e} className='auto-item' key={Math.random()}>
      <div className='img-wrapper'>
        <Avatar
          alt={b.name}
          imgProps={{ referrerPolicy: "no-referrer" }}
          src={b.logo}
          variant='square'
          style={{
            width: "30px",
            height: "30px",
            objectFit: "contain",
          }}
          sizes={"xs"}
        >{b.buyer.name.toString().substr(0, 1).toUpperCase()}</Avatar>
      </div>
      <div><b style={{ 'marginRight': '4px' }}>
        {b.buyer.name} ({b.invoiceNumber})
      </b>
        {/* {!b.buyer.counterPartyOfAccount && <Tooltip title="Verified account"><InfoIcon style={{ fontSize: '12px', color: '#09b2ee' }}>dagdas</InfoIcon></Tooltip>}
         {b.buyer.counterPartyOfAccount && <Tooltip title="My customer / vendor"><InfoIcon style={{ fontSize: '12px', color: '#aaa' }}></InfoIcon></Tooltip>} */}
      </div>
    </div>
  };

  /* Search Invoice and set to all fields */


  useEffect(() => {
    console.log("useeffect called 1111");
    if (invoiceSeqData) {
      console.log("invoiceSeqdata is present")
      console.log(invoiceSeqData)
      if (type === MODULE_TYPE && !isEditing) {
        console.log(!isEditing);
        console.log("setting of creditNoteNumber");
        methods.setValue("invoiceNumber", invoiceSeqData.invoiceNumber);
        methods.setValue("terms", invoiceSeqData.termsAndConditions);
        methods.setValue("footer1", invoiceSeqData.footer1);
        setIsLoading(false)
      }
      setTimeout(() => setIsFormLoaded(false), 1000);
    }
  }, [invoiceSeqData, methods, type, selectedInvoiceP])

  useEffect(() => {
    console.log("useeffect called 99999")
    if (type === MODULE_TYPE) {
      if (documentSettings.length === 0 && isEditing)
        dispatch(fetchDocumentSettings(selectedAccount._id));

      if (documentSettings.length > 0) {
        let obj = documentSettings.find((o: any) => o.documentType.name.toLowerCase() === 'credit note');
        setDocumentSettingId(obj?._id || '');
      }
    }
  }, [selectedAccount, documentSettings, dispatch, type, isEditing])

  //Fetch current selected account .
  useEffect(() => {
    console.log("useeffect called if fetch data 8888 ");
    console.log(fetchData);
    if (fetchData)
      console.log("useeffect called from fetchdata ");
      getEstimateDetails();
  }, [dispatch, fetchData]);

  //Fetch all last estimate seq number and estimate details.
  useEffect(() => {
    console.log("useeffect called if  isEditing && 'account-receivable' 9999 ")
    if (!isEditing && type === MODULE_TYPE)
    console.log("calling getEstimateDetails from last ")
      getEstimateDetails();
  }, [isEditing]);

  const setAddesses = (object: any) => {
    methods.setValue("shippingAddress", '')
    methods.setValue("billingAddress", '')
    let address = object.addresses;
    let shippingAddress = address.find((item: any) => item.type === 'Shipping') || [];
    let billingAddress = address.find((item: any) => item.type === 'Billing') || [];
    if (shippingAddress) {
      let countryName = countries.find((item: any) => item._id === shippingAddress.country);
      let _shippingAdddress = [shippingAddress.city, shippingAddress.state, countryName?.name, shippingAddress.line1, shippingAddress.line2, shippingAddress.code];
      methods.setValue("shippingAddress", _shippingAdddress.filter(n => n).join(", "));
    }
    if (billingAddress) {
      let countryName = countries.find((item: any) => item._id === billingAddress.country);
      let _billingAddress = [billingAddress.city, billingAddress.state, countryName?.name, billingAddress.line1, billingAddress.line2, billingAddress.code];
      methods.setValue("billingAddress", _billingAddress.filter(n => n).join(", "));
    }
  };

  useEffect(() => {
    console.log("calling useEffect for setting address and client Name")
    console.log(selectedClient);

    if (selectedClient) {

      if (type === MODULE_TYPE) { setAddesses(selectedClient) }
      methods.setValue("client", selectedClient.name);
      setIsClientLoading(false);
    }

    if (selectedAgent) {
      methods.setValue("agent", selectedAgent.name);
      setIsAgentLoading(false);
    }

    

    if (placeOfSupply) {
      console.log("place of supply value 9999999   " + placeOfSupply);
      console.log(placeOfSupply);
      methods.setValue("placeOfSupply", placeOfSupply);
    }
  }, [selectedClient, placeOfSupply, selectedAgent, methods, countries]);

  useEffect(() => {
    if (!isEditing) {
      methods.setValue("account", selectedAccount.name);
      methods.setValue("date", valueDate.toString());
      methods.setValue("paymentTerms", "Net-30");
      if (type === MODULE_TYPE)
        setPayToAccount(selectedAccount)
    }
  }, [methods, selectedAccount, debitNoteDate, isEditing, type]);

  useEffect(() => {
    console.log("updating InLineFields useeffect 10000000000")
    const updateInLineFeild = async () => {
      if (inLineItems.length > 0) {
        let initialSum = 0;
        let sumWithInitial = inLineItems.reduce((previousValue, currentValue) => previousValue + currentValue.total, initialSum);

        let taxAmount = 0;
        let tax1 = 0;
        let tax2 = 0;
        let tax3 = 0;
        inLineItems.forEach((item) => {
          taxAmount += item.amount;
          tax1 += item.sgsttotal;
          tax2 += item.cgsttotal;
          tax3 += item.igsttotal;
        })
        methods.setValue("lineItem", 'filled');
        methods.setValue("amount", sumWithInitial);
        methods.setValue("amountFormat", Utils.formatNumber(sumWithInitial, true));
        methods.setValue("taxAmount", Utils.formatNumber(taxAmount, true));
        methods.setValue("tax1", tax1.toString());
        methods.setValue("tax1Format", Utils.formatNumber(tax1.toString(), true));
        methods.setValue("tax2", tax2.toString());
        methods.setValue("tax2Format", Utils.formatNumber(tax2.toString(), true));
        methods.setValue("tax3", tax3.toString());
        methods.setValue("tax3Format", Utils.formatNumber(tax3.toString(), true));
      } else
        methods.setValue("lineItem", '');
    };

    updateInLineFeild();
  }, [inLineItems, methods]);

  useEffect(() => {
    if (docs.length > 0 && fetchDocs) {
      let len = docs.length;
      setDocData(d => [...d, docs[len - 1]]);
    }
  }, [docs, fetchDocs])

  useEffect(() => {
    if (type === 'account-payable') {
      setIsBuyerLoading(true);
      dispatch(fetchAccountsByName(selectedAccount.name)).unwrap().then((data) => {
        if (data) {
          data.accounts = data.accounts.filter(function (item) {
            return item._id == selectedAccount._id;
          });
          setSelectedBuyer(data.accounts[0]);
          setAddesses(data.accounts[0]);
          setIsBuyerLoading(false);
        }
      });
    }
  }, [selectedAccount])

  const handleChange = (event: SelectChangeEvent<any>) => {
    setSelectedState(event.target.value);

  };

  return (
    <StyledCard sx={{ pb: 5 }}>
      <FormProvider {...methods}>
        <CardContent className={'invoiceContent'}>
          <Typography className={'cardHeader'} variant="h4" component="div" style={{}}>
            <Box>{isEditing ? "Edit Debit Note" : "Create Debit Note"}</Box>
            <Box style={{ fontWeight: 'normal', alignItems: 'center', display: 'flex', flexDirection: 'row' }}>{(type === MODULE_TYPE) && "Debit Note Setup"}
              {(type === MODULE_TYPE) && <Tooltip title="Debit Note Setup"><SettingsIcon style={{ marginLeft: '5px', cursor: 'pointer' }} onClick={() => { openCloseDrawer('document') }} fontSize="small" /></Tooltip>}</Box>
          </Typography>
          <Box component="form" onSubmit={methods.handleSubmit(data => onSubmitForm(data))} ref={formRef} noValidate sx={{ mt: 0 }} style={{ position: 'relative' }}>
            {isformLoaded && <StyledBoxLoader component="div" sx={{ mt: 1 }}><CircularProgress color="inherit" /></StyledBoxLoader>}
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Grid container style={{ justifyContent: 'space-between', padding: '20px 10px', backgroundColor: '' }}>
                <Grid item md={3} xs={12}>
                  {isLoading ? <div></div> : <CustomTextField variant="standard" label="Invoice No." name="invoiceNumber" required InputProps={{ readOnly: (type === MODULE_TYPE || (isEditing && type === MODULE_TYPE)) ? true : false, disabled: (type === MODULE_TYPE) ? true : false }} className={(type === MODULE_TYPE) ? 'disabledField' : ''} />}
                </Grid>
                <Grid item md={3} xs={12}>
                  {isLoading ? <div></div> : <CustomTextField variant="standard" label="Ref Invoice Number" name="refInvoiceNumber" />
                  }
                </Grid>
                <Grid item md={2} xs={12}>
                  <Stack style={{ marginTop: '16px', marginBottom: '8px', flexDirection: 'row', alignItems: 'center' }}>
                    <DesktopDatePicker
                      label="Invoice Date"
                      inputFormat="dd/MM/yyyy"
                      maxDate={moment().add(1).toDate()}
                      value={valueDate}
                      onChange={(value) => { handleDateChange(value, 'valueDate') }}
                      renderInput={(params) => <TextField {...params} name={'valueDate'} required variant="standard" style={{ marginRight: (type === 'account-receivable') ? '10px' : '0px', flex: 1 }} />}
                    />
                  </Stack>
                </Grid>
                <Grid item md={4} xs={12}>
                  {isLoading ? <div></div> : <CustomTextField variant="standard" label="Invoice Number" name="invoiceId" style={{ display: 'none' }} className={'hiddenText'}/>
                  }

                  <Stack direction="row" style={{ alignItems: 'center' }} spacing={1}>
                    <Autocomplete
                      ref={elmRef}
                      id={`Search Ref Invoice`}
                      freeSolo
                      onChange={onChangeHandler1}
                      onInputChange={onInputChangeHandler1}
                      options={invoiceOptions}
                      renderOption={handleRenderOption1}
                      getOptionLabel={(option) => option.invoiceNumber}
                      renderInput={(params) => <CustomTextField {...params} variant="standard" name="search12" label={`Search Ref Invoice`} />}
                      style={{ width: '100%' }}
                    />
                    <Tooltip title="Add new"><AddIcon style={{ cursor: 'pointer', marginTop: '16px' }} fontSize="medium" /></Tooltip>
                  </Stack>
                </Grid>
                
                <Grid item md={3} xs={12}></Grid>
              </Grid>
              <Grid container style={{ justifyContent: 'space-between', padding: '20px 10px', backgroundColor: '' }}>
                <Grid item md={6} xs={12}>
                  {(type === MODULE_TYPE) && <div style={{ display: 'flex' }}>
                    <Avatar
                      alt={selectedAccount.name || 'Picture'}
                      imgProps={{ "referrerPolicy": 'no-referrer' }}
                      src={selectedAccount.logo}
                      style={{ width: '60px', height: '60px', objectFit: 'contain', marginRight: '10px' }}
                    />
                    {isLoading ? <div></div> : <CustomTextField className={'disabledField'} label="Supplier" variant="standard" name="account" InputProps={{ readOnly: true, disabled: true }} />}
                  </div>}
                </Grid>
                <Grid item md={6} xs={12}>
                  {stateOptions && <CustomSelect
                    name="placeOfSupply"
                    label="Select Place of Supply"
                    id="state"
                    variant="standard"
                    options={stateOptions}
                    // value={selectedState}
                    value={placeOfSupply ?? ''}
                    placeholder="Select Place of Supply"
                    // onChange={(event: SelectChangeEvent<any>) => { handleChange(event) }} 

                    onChange={(event: SelectChangeEvent<any>) => {
                      methods.setValue("placeOfSupply", event.target.value);
                      setPlaceOfSupply(event.target.value);
                    }}
                    />
                  }
                </Grid>
                <Grid item md={6} xs={12}>
                  {(type === MODULE_TYPE) && <>
                    <Stack style={{ flexDirection: 'row', alignItems: 'center', marginTop: '0px' }}>
                      <Avatar
                        alt={selectedClient?.name || ''}
                        imgProps={{ "referrerPolicy": 'no-referrer' }}
                        src={selectedClient?.logo || ''}
                        style={{ width: '60px', height: '60px', objectFit: 'contain', marginRight: '10px' }}
                      />
                      {isClientLoading ? <div></div> : <CustomTextField className={'disabledField'} variant="standard" label={"Buyer"} name="client" required placeholder={'Needs to be selected from drawer'} InputProps={{ readOnly: true, disabled: true }} />}

                      <Tooltip title="Search or Add New Buyer"><SearchIcon style={{ cursor: 'pointer' }} onClick={() => { openCloseDrawer('buyer') }} fontSize="medium" /></Tooltip>
                    </Stack>
                  </>}
                </Grid>
                <Grid item md={6} xs={12}>
                  <TemplateSelect invoiceId={invoiceId} invoiceStatus={invoiceStatus} invoiceDocType={'sale-credit-note'} />
                </Grid> 
                <Grid item md={6} xs={12}>
                  {isClientLoading || isBuyerLoading ? <div></div> : <CustomTextField className={'disabledField'} style={{ }} variant="standard" multiline label={"Bill To"} name="billingAddress" required InputProps={{ readOnly: true, disabled: true }} />}
                </Grid>
                <Grid item md={6} xs={12}>
                  {isClientLoading || isBuyerLoading ? <div></div> : <CustomTextField className={'disabledField'} style={{ }} variant="standard" multiline label={"Ship To"} name="shippingAddress" required InputProps={{ readOnly: true, disabled: true }} />}
                </Grid>
                
              </Grid>
              <TableInlineEdit onChangeRow={rowOnChangeHandler} rowsData={editInLineItems} />

              {/* <Typography>some text goess here {JSON.stringify(stateOptions)}</Typography> */}

              <Grid container sx={{ mt: 0 }} style={{ justifyContent: 'space-between', padding: '0px 6px' }}>
                <Grid item md={12} xs={12}><CustomTextField className={'hiddenText'} variant="standard" label="" name="lineItem" required /></Grid>
                <Grid item xs={8}>

                </Grid>
                <Grid item xs={4}>
                  <Grid item xs={12}>
                    <CustomTextField className={`disabledField text-right`} label="Taxable Amount" variant="standard" name="taxAmount" InputProps={{ readOnly: true, disabled: true }} />
                    <CustomTextField className={`disabledField text-right`} label="IGST" variant="standard" name="tax3Format" InputProps={{ readOnly: true, disabled: true }} /><CustomTextField style={{ display: 'none' }} className={'hiddenText'} variant="standard" label="" name="tax3" />
                    <CustomTextField className={`disabledField text-right`} label="CGST" variant="standard" name="tax2Format" InputProps={{ readOnly: true, disabled: true }} /><CustomTextField style={{ display: 'none' }} className={'hiddenText'} variant="standard" label="" name="tax2" />
                    <CustomTextField className={`disabledField text-right`} label="SGST" variant="standard" name="tax1Format" InputProps={{ readOnly: true, disabled: true }} /><CustomTextField style={{ display: 'none' }} className={'hiddenText'} variant="standard" label="" name="tax1" />
                    <CustomTextField className={`disabledField text-right`} label="Total" variant="standard" name="amountFormat" required InputProps={{ readOnly: true, disabled: true }} /><CustomTextField style={{ display: 'none' }} className={'hiddenText'} variant="standard" label="" name="amount" />
                  </Grid>
                </Grid>

                

                {(type === MODULE_TYPE) && <>
                  <Grid item md={12} xs={12}>
                    {isLoading ? <div></div> : <CustomTextField variant="standard" multiline label="Terms & Conditions" name="terms" />}
                  </Grid>

                  <Grid item md={12} xs={12}>
                    {isLoading ? <div></div> : <CustomTextField variant="standard" multiline label="Footer" name="footer1" InputProps={{ readOnly: true, disabled: true }} className={'disabledField'} />}
                  </Grid>
                </>}
              </Grid>
            </LocalizationProvider>

            <DebitNoteButtons type={type} selectedSend={selectedDispatchHandler} invoiceStatus={invoiceStatus} onCancel={onCancel} />
          </Box>
        </CardContent>
      </FormProvider>

      <Drawer anchor="right" open={open[0]}>
        {<DialogDocumentSettingForm open={open[0]} setDocumentType={'invoice'} documentSettingId={documentSettingId} accountId={selectedAccount._id} onClose={closeDialog}></DialogDocumentSettingForm>}
      </Drawer>
      <Drawer anchor="right" open={open[3]} >
        {<DialogClientForm open={open[3]} title={'Buyer'} onClose={closeDialog} onCancel={cancelDialog} selectedData={selectedClientHandler}></DialogClientForm>}
      </Drawer>
    </StyledCard>
  );
}

export default DebitNote;